module.exports = __webpack_public_path__ + "static/img/product17.9243f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product17.png
// module id = MzfQ
// module chunks = 1